module.exports = __webpack_public_path__ + "static/img/shangbiao_07.98ea046.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_07.png
// module id = TkN0
// module chunks = 0